<template>
    <div class="innerCell" :class="{withFab: fab}" @mouseover="showFilter = true" @mouseleave="showFilter = false">
        {{ params.value }}
        <v-speed-dial v-if="showFilter" v-model="fab" open-on-hover direction="left" class="filter_icon d-flex">
            <template v-slot:activator>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs"
                               v-on="on"
                               x-small
                               icon
                               color="primary darken-1"
                               @click="onFilterClick"
                        >
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                    </template>
                    Filter by value
                </v-tooltip>
            </template>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs"
                           v-on="on"
                           x-small
                           icon
                           color="success"
                           @click="onCopyToClipboardClick"
                    >
                        <v-icon>mdi-clipboard-multiple</v-icon>
                    </v-btn>
                </template>
                Copy to clipboard
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs"
                           v-on="on"
                           x-small
                           icon
                           color="accent"
                           @click="onHighlightClick"
                    >
                        <v-icon>mdi-auto-fix</v-icon>
                    </v-btn>
                </template>
                Highlight the value
            </v-tooltip>
        </v-speed-dial>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            fab: false,
            showFilter: false
        }
    },
    methods: {
        onFilterClick() {
            this.params.onFilterClickCallback(this.params.column.colId, this.params.value)
        },
        onHighlightClick() {
            this.params.onHighlightClickCallback(this.params.column.colId, this.params.value)
        },
        onCopyToClipboardClick() {
            navigator.clipboard.writeText(this.params.value)
        }
    }
})
</script>
<style>
.innerCell {
    padding-right: 20px;
    position: relative;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.innerCell.withFab {
    padding-right: 90px;
    transition: 0.1s;
}

.innerCell > .filter_icon {
    position: absolute;
    right: 0;
    top: 0;
}

.filter_icon > .v-speed-dial__list {
    padding-right: 0 !important;
}
</style>
